import {useMutation, useQuery} from 'admin/lib/apollo'
import {GET_PAYMENT_RULE, CREATE_PAYMENT_RULE, UPDATE_PAYMENT_RULE} from 'admin/gql/PaymentRule.gql'
import clearCache from './clearCache'
import useDestroyable from 'admin/hooks/useDestroyable'

export default (organisationId, paymentRuleId) => {
  const {data: {paymentRule = {}} = {}, error: getError} = useQuery(GET_PAYMENT_RULE, {
    variables: {organisationId, paymentRuleId},
    skip: !paymentRuleId
  })

  const [create, {error: createError}] = useMutation(CREATE_PAYMENT_RULE, {
    variables: {organisationId},
    flash: 'Payment rule created',
    update: cache => clearCache({organisation: {id: organisationId}})(cache)
  })

  const [update, {error: updateError}] = useMutation(UPDATE_PAYMENT_RULE, {
    variables: {organisationId, paymentRuleId},
    flash: 'Payment rule updated'
  })

  const {destroy, errors: destroyError} = useDestroyable('BankRule', paymentRuleId)

  return {
    paymentRule,
    errors: getError || createError || updateError || destroyError || {},
    create,
    update,
    destroy
  }
}
